// Owner-scoped, memory-only drafts survive an expired session without writing inventory to browser storage.
export const itemDrafts = new Map<string, unknown>();
